import { useEffect, useState } from "react";
import { useScript } from "@jti/ui";
export const useKakao = ({ kakaoSdkLink, integrityKey, sdkKey }) => {
    const [isScriptInitiated, setIsScriptInitiated] = useState(false);
    const [isInitiationFailed, setIsInitiationFailed] = useState(false);
    const { scriptStatus } = useScript({
        scriptSrc: kakaoSdkLink,
        attributes: { integrity: integrityKey, crossOrigin: "anonymous" },
    });
    useEffect(() => {
        if (scriptStatus !== "ready" || !window.Kakao)
            return;
        try {
            if (!window.Kakao.isInitialized()) {
                window.Kakao.init(sdkKey);
            }
            setIsScriptInitiated(true);
        }
        catch (error) {
            console.error(error);
            setIsInitiationFailed(true);
        }
    }, [scriptStatus, sdkKey]);
    return {
        scriptStatus,
        isScriptInitiated,
        isInitiationFailed,
    };
};
